// Pop-up: close the statement cycle (freezes the numbers).
// Part of the Balances page (components/Balances.jsx). Split out 2026-10-14.
import { fmtCycleLabel } from './helpers.js';

export default function CloseCycleModal({ closeBusy, closeNotes, closeOpen, confirmClose, customers, cycleKey, from, setCloseNotes, setCloseOpen, to }) {
  return (
    <>
      {closeOpen && (
        <div className="modal-backdrop" onClick={() => !closeBusy && setCloseOpen(false)}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 480, maxWidth: 620 }}>
            <h3 style={{ marginTop: 0, color: '#b91c1c' }}>🔒 Close statement cycle {fmtCycleLabel(cycleKey)}?</h3>
            <div className="card" style={{ padding: '0.5rem 0.75rem', background: '#fef9c3', marginBottom: '0.75rem', fontSize: '0.9em', color: '#854d0e' }}>
              <strong>Once closed, this cycle is immutable.</strong> Per-customer closing balances are snapshotted to the database. The next cycle's opening balance for each customer = this cycle's closing. New rows that happen to land in this period will NOT shift the snapshot retroactively (but they will create variance you'll need to handle outside the cycle).
            </div>
            <p className="small" style={{ marginTop: 0, color: '#666' }}>
              Customers in snapshot: <strong>{customers.length}</strong> · Period: <strong>{from}</strong> → <strong>{to}</strong>
            </p>
            <label className="small" style={{ display: 'block', marginBottom: '0.5rem' }}>
              Closing notes (optional — written to audit log)
              <input type="text" value={closeNotes} onChange={e => setCloseNotes(e.target.value)} style={{ width: '100%' }}
                     placeholder="e.g. closed early to match Igor's mid-month review" />
            </label>
            <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
              <button className="refresh-btn" onClick={confirmClose} disabled={closeBusy} style={{ background: '#b91c1c' }}>
                {closeBusy ? 'Closing…' : '🔒 Close cycle (snapshot + lock)'}
              </button>
              <button className="refresh-btn" onClick={() => setCloseOpen(false)} disabled={closeBusy} style={{ background: '#888' }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
